import { fetchThroughputByTeam } from "../api/aiMetricsApi";
import { makeAdoMetricHook } from "./useAdoMetric";
import { ADO_QUERY_KEYS } from "./adoQueryKeys";

export const useAdoThroughputByTeam = makeAdoMetricHook(
  ADO_QUERY_KEYS.throughputByTeam,
  fetchThroughputByTeam,
);
